/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Option_500_DescInputs */

const es_gift_option_500_desc = /** @type {(inputs: Gift_Option_500_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los peces te piden permiso para nadar.`)
};

const gl_gift_option_500_desc = /** @type {(inputs: Gift_Option_500_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os peixes pedenche permiso para nadar.`)
};

const en_gift_option_500_desc = /** @type {(inputs: Gift_Option_500_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fish ask your permission to swim.`)
};

/**
* | output |
* | --- |
* | "Fish ask your permission to swim." |
*
* @param {Gift_Option_500_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_option_500_desc = /** @type {((inputs?: Gift_Option_500_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Option_500_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_option_500_desc(inputs)
	if (locale === "en") return en_gift_option_500_desc(inputs)
	return es_gift_option_500_desc(inputs)
});